<div class="auto-reservation-container">
  <div class="header-content">
    <div class="info">{{ 'AUTOS_MODULE.CARD.INFO' | transloco }}</div>
    <div class="image" [ngStyle]="getBackgroundImage('image')">
      <div class="logo" [ngStyle]="getBackgroundImage('logo')"></div>
    </div>
  </div>
  <h3>{{ model }}</h3>
  <div class="box">
    <app-auto-info-view [data]="info"></app-auto-info-view>
  </div>
  <div class="box" *ngIf="hasRateDescription">
    <app-auto-detail-rate-description [autoInfo]="info"></app-auto-detail-rate-description>
  </div>
  <div class="places">
    <div class="place pickup">
      <h4>{{ 'AUTOS_MODULE.DETAILS.PICKUP' | transloco }}:</h4>
      <p class="datetime">{{ pickUp }} • {{ pickUpTime }}</p>
      <p class="address">{{ pickUpPlace }}</p>
    </div>
    <div class="place dropoff">
      <h4>{{ 'AUTOS_MODULE.DETAILS.DROPOFF' | transloco }}:</h4>
      <p class="datetime">{{ dropOff }} • {{ dropOffTime }}</p>
      <p class="address">{{ dropOffPlace }}</p>
    </div>
  </div>
  <div class="period">
    <h4>{{ 'AUTOS_MODULE.DETAILS.PERIOD' | transloco }}:</h4>
    <p class="datetime">{{ period }}</p>
  </div>
</div>
<div class="simple-box">
  <app-auto-policies-detail
    [content]="contract"
    [provider]="autoValidation.VehicleOption.Provider">
  </app-auto-policies-detail>
</div>
<div class="details">
  <app-auto-detail-rates
    [period]="period"
    [currency]="currency"
    [rates]="rates"
    [conversionRate]="conversionRate">
  </app-auto-detail-rates>
</div>
